import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import {ValidatonError} from '../resources/GenericResource';


const SettingsNotificationsFormModel = t.struct({
    email_candidate_applied: t.Bool,
    email_chat_replied: t.Bool,
    email_shift_due: t.Bool,
    email_shift_updated: t.Bool
});


class FormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;
        return (
                /*<div className="tab-section">
                    <h2 className="tab-section-title">Notify me when</h2>

                    <label className="form-control form-control-checkbox">
                        <input type="checkbox" defaultChecked />
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">New candidate applies for a shift</span>
                    </label>

                    <label className="form-control form-control-checkbox">
                        <input type="checkbox" />
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Candidate replies to my message</span>
                    </label>

                    <label className="form-control form-control-checkbox">
                        <input type="checkbox" defaultChecked />
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Shift is due in 24 hours</span>
                    </label>

                    <label className="form-control form-control-checkbox">
                        <input type="checkbox" />
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Team member updates the shift information</span>
                    </label>
                </div>*/

                <div className="tab-section">
                    <h2 className="tab-section-title">Email me when</h2>

                    <label className="form-control form-control-checkbox">
                        {inputs.email_candidate_applied}
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">New candidate applies for a shift</span>
                    </label>

                    <label className="form-control form-control-checkbox">
                        {inputs.email_chat_replied}
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Candidate replies to my message</span>
                    </label>

                    <label className="form-control form-control-checkbox">
                        {inputs.email_shift_due}
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Shift is due in 24 hours</span>
                    </label>

                    <label className="form-control form-control-checkbox">
                        {inputs.email_shift_updated}
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Shift information is updated</span>
                    </label>
                </div>

                /*<div className="tab-section">
                    <h2 className="tab-section-title">Newsletter</h2>

                    <label className="form-control form-control-checkbox">
                        <input type="checkbox" defaultChecked />
                        <span className="fake-checkbox"></span>
                        <span className="checkbox-description">Subscribe me to the Gigpanel newsletter</span>
                    </label>
                </div>*/
        );
    }
}

function makeLayout(locals) {
    return <FormLayout {...locals}/>
}

const Form = baseFormFactory(SettingsNotificationsFormModel, true, true);

class SettingsNotificationsForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        const value = props.initialFormData;

        this.state = {
            isValid,
            value
        };
    }

    getOptions() {

        return {
            auto: 'none',

            template: makeLayout,

            fields: {
                email_candidate_applied: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                },

                email_chat_replied: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                },

                email_shift_due: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                },

                email_shift_updated: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

SettingsNotificationsForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func
};


export default SettingsNotificationsForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/SettingsNotificationsForm.js
 **/